import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from '../contexts/AuthContext';

interface PromoterStatus {
  loading: boolean;
  hasProfile: boolean;   // une candidature promoteur existe
  codeActive: boolean;   // promoteur validé + contrat signé
  affiliateCode: string | null;
}

// Lit /promoters/{uid} pour savoir si l'utilisateur courant est promoteur actif.
// Léger (1 getDoc). Utilisé pour piloter l'affichage du CTA "Devenir Promoteur".
export function usePromoterStatus(): PromoterStatus {
  const { user } = useAuth();
  const [state, setState] = useState<PromoterStatus>({
    loading: true, hasProfile: false, codeActive: false, affiliateCode: null,
  });

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!user) {
        if (!cancelled) setState({ loading: false, hasProfile: false, codeActive: false, affiliateCode: null });
        return;
      }
      try {
        const snap = await getDoc(doc(db, 'promoters', user.uid));
        if (cancelled) return;
        if (snap.exists()) {
          const d = snap.data();
          setState({ loading: false, hasProfile: true, codeActive: d.codeActive === true, affiliateCode: d.affiliateCode || null });
        } else {
          setState({ loading: false, hasProfile: false, codeActive: false, affiliateCode: null });
        }
      } catch {
        if (!cancelled) setState({ loading: false, hasProfile: false, codeActive: false, affiliateCode: null });
      }
    }
    load();
    return () => { cancelled = true; };
  }, [user]);

  return state;
}
